import { tokenStore } from "@app/stores/auth.store.ts";
import { useStore } from "@tanstack/react-store";
import { useMemo } from "react";
import { EngineApi } from "./engine";

export function useApis() {
    const token = useStore(tokenStore);

    const authHeaders: HeadersInit | undefined = useMemo(() => {
        // queryClient.clear();

        if (token == undefined) {
            return undefined;
        }
        return {
            Authorization: `Bearer ${token}`,
        };
    }, [token]);

    const engine = useMemo(
        () =>
            new EngineApi({
                baseUrl: import.meta.env.VITE_TS_ENGINE_URL,
                baseApiParams: {
                    headers: authHeaders,
                },
            }),
        [authHeaders],
    );

    return {
        engine,
    };
}
